import { useMutation } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { MutationConfig } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

import { isResponseError } from '../../../../api/config';
import { entryActionCustomValidateOptions } from '../../../../api/inbox';
import { StatusFilterEnum, UpdateFileEntryResponse } from '../../../../types';
import { addSidebarInboxFileEntry } from '../../../Sidebar/api/inboxEntries';

const url = `${PREFIX_URL}/inbox-documents/:fileId/duplicate`;

export type DuplicateFileDTO = {
  fileId: number;
};

export const duplicateFile = ({ fileId }: DuplicateFileDTO): Promise<UpdateFileEntryResponse> => {
  return axios.post(generateRoutePath(url, { fileId }), {
    ...entryActionCustomValidateOptions,
  });
};

type DuplicateFileOptions = {
  projectId: string;
  fileId: number;
  filter: StatusFilterEnum;
  config?: MutationConfig<typeof duplicateFile>;
};

export const useDuplicateFile = ({ projectId, fileId, config, filter }: DuplicateFileOptions) => {
  return useMutation({
    onSuccess: (data) => {
      if (isResponseError(data)) {
        return;
      }

      addSidebarInboxFileEntry({
        projectId,
        filter,
        newInboxEntry: data.data['inbox-entry'],
        newFileEntry: data.data['inbox-document'],
      });
    },
    ...config,
    mutationFn: () => duplicateFile({ fileId }),
  });
};
